module.exports = __webpack_public_path__ + "static/media/giet.0fb8ec8b.png";